import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import {
  IConfigurationStaffUpdatePutBody,
  IConfigurationStaffUpdateResponse,
} from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useConfigurationStaffUpdateAPI = () => {
  const [updatedStaffId, setUpdatedStaffId] = useState<string>("");
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const execute = useCallback(
    async (staffData: IConfigurationStaffUpdatePutBody) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        if (!staffData) {
          return;
        }
        await axios
          .put(`${CONFIGURATION_APIS?.STAFF_UPDATE?.baseURL}` , staffData, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IConfigurationStaffUpdateResponse>) => {
            if (res.data.status === true) {
              setUpdatedStaffId(res.data.data.staff_id);
              toast.success(`${staffData?.staff_name} has been updated successfully`);
            } else {
              toast.error("Error while updating staff details.");
            }
          })
          .catch((e: AxiosError) => {
            captureError(e)
            sendCurl(e.config["curlCommand"]);
          });
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          if (axiosError.code === "ERR_BAD_REQUEST") {
            toast.error("Error at server while fetching staff details.");
          }
          if (axiosError.response?.status === 400) {
            toast.error(axiosError.message);
          }
          if (axiosError.response?.status === 500) {
            toast.error("Internal Server Error, Contact Tech Team.");
          }
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [configuration],
  );
  return { updatedStaffId, execute };
};
